module.exports = __webpack_public_path__ + "static/official_website_new/img/rotationChart2.69145d8b.jpg";